import { Lightning as lng, Log } from '@lightningjs/sdk';
import { Button } from '../../../components/shared/Button';

export class ActionButton extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      flex: { direction: 'row' },
      Button: {
        type: Button,
        h: 60,
        label: this.bindProp('label'),
        iconRight: this.bindProp('iconRight'),
        signals: {
          onActivate: '_activate',
        },
      },
    };
  }

  _activate() {
    if (this._actionHandler && this._actionHandler.doAction) {
      this._actionHandler.doAction(this.modalOwner);
    } else {
      Log.error('[ActionButton]', 'No action associated with this button', `Label: ${this.label}`);
    }
  }

  /**
   * @param {Backend} b
   */
  set backend(b) {
    this._backend = b;
  }

  /**
   * @param {DetailAction} h
   */
  set actionHandler(h) {
    h.owner = this;
    this._actionHandler = h;
  }

  _getFocused() {
    return this.tag('Button');
  }
}
